var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-text-field", {
    ref: "field",
    attrs: {
      value: _setup.text,
      label: _vm.label,
      dense: _vm.dense,
      outlined: _vm.outlined,
      disabled: _vm.disabled,
      clearable: _vm.clearable,
      "prepend-inner-icon": _vm.prependInnerIcon,
      "error-messages": _vm.errorMessages,
      "hide-details": _vm.hideDetails,
      placeholder: "dd/mm/aaaa",
      maxlength: "10",
      inputmode: "numeric",
      autocomplete: "off",
    },
    on: {
      input: _setup.onInput,
      blur: _setup.onBlur,
      keydown: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        )
          return null
        return _setup.onBlur.apply(null, arguments)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "append",
        fn: function () {
          return [
            _c(
              "v-menu",
              {
                attrs: {
                  "close-on-content-click": false,
                  disabled: _vm.disabled,
                  transition: "scale-transition",
                  "offset-y": "",
                  left: "",
                  "min-width": "auto",
                },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-icon",
                          _vm._g(
                            _vm._b(
                              {
                                staticStyle: { cursor: "pointer" },
                                attrs: { disabled: _vm.disabled },
                              },
                              "v-icon",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [_vm._v("mdi-calendar-today")]
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _setup.menu,
                  callback: function ($$v) {
                    _setup.menu = $$v
                  },
                  expression: "menu",
                },
              },
              [
                _c("v-date-picker", {
                  attrs: {
                    value: _setup.isoValue,
                    locale: "pt-BR",
                    "no-title": "",
                  },
                  on: { input: _setup.onPick },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }